import React from "react";
import { Button, Tabs } from "antd";
import ProfileSectionPosts from "./ProfileSectionPosts";
import useMyProfileStore from "@/hooks/useMyProfileStore";
import ProfileSectionActivityV2 from "./ProfileSectionActivityV2";
import ProfileAboutWidget from "./ProfileAboutWidget";
import ProfileWidgetLinkedIn from "./ProfileWidgetLinkedIn";
import ProfileMilestone from "./ProfileMilestone";
import ProfileListCard from "@/components/Card/ProfileListCard";
import ProfileExpertiseWidget from "./ProfileExpertiseWidget";
import ProfileFavoritesWidget from "./ProfileFavoritesWidget";
import ProfileInterestWidget from "./ProfileInterestWidget";
import ProfileEndorsementWidget from "./ProfileEndorsementWidget";
import useWindowResize from "@/hooks/useWindowResize";
import { useRouter } from "next/router";
import { useMyActivityV3 } from "@/hooks/useMyActivityV3";

export enum myProfileTabKey {
  POST = "POST",
  ACTIVITY = "ACTIVITY",
}

interface IMyProfileTabsContent {
  refetch?: () => void;
  isLoading?: boolean;
}

const MyProfileTabsContent: React.FC<IMyProfileTabsContent> = ({
  refetch,
  isLoading,
}) => {
  const router = useRouter();
  const { userView, setState } = useMyProfileStore();
  const isMobile = useWindowResize();
  const { fetchMyActivities } = useMyActivityV3({});

  return (
    <Tabs
      onDoubleClick={() => fetchMyActivities()}
      defaultActiveKey={(router?.query?.defaultTab as string) || "post"}
      className="tab-mobile-profile"
      items={[
        {
          key: myProfileTabKey.POST,
          label: "My Posts",
          children: <ProfileSectionPosts dataUser={userView} isPost={true} />,
        },
        {
          key: myProfileTabKey.ACTIVITY,
          label:  "My Activity",
          children: <ProfileSectionActivityV2 />,
        },
        ...(isMobile
          ? [
              {
                key: "about-me",
                label: "About Me",
                children: (
                  <div className="flex flex-col gap-4 w-full">
                    <ProfileAboutWidget />
                    <ProfileWidgetLinkedIn
                      userId={userView?.userId as string}
                      refetchUserData={refetch as never}
                      isLoadingFetch={isLoading as boolean}
                      linkedInData={
                        userView?.user?.socialMedia?.linkedIn as string
                      }
                      _version={userView?.user?._version as number}
                    />
                    <ProfileMilestone />
                    <ProfileListCard
                      users={userView?.champions}
                      title="My Champions"
                      emptyMessage="Earn points by highlighting your champions here!"
                      extraNode={
                        (userView?.champions?.length || 0) < 6 ? (
                          <div className="mt-2">
                            <Button
                              type="primary"
                              onClick={() =>
                                setState({ isModalRequestChampionOpen: true })
                              }
                            >
                              Invite to Circle of Champions
                            </Button>
                          </div>
                        ) : null
                      }
                    />
                    <ProfileExpertiseWidget />
                    <ProfileFavoritesWidget isVisiting={false} />
                    <ProfileInterestWidget />
                    <ProfileEndorsementWidget openEndorsementModal={() => {}} />
                  </div>
                ),
              },
            ]
          : []),
      ]}
    />
  );
};

export default MyProfileTabsContent;
